/* 🤖 this file was generated by script */
export const wiconFlexAlignLeft = {
  name: 'flex_align_left',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6.5 17.5v-11M7.8 3h8.4c1.68 0 2.52 0 3.16.33a3 3 0 011.31 1.3c.33.65.33 1.49.33 3.17v8.4c0 1.68 0 2.52-.33 3.16a3 3 0 01-1.3 1.31c-.65.33-1.49.33-3.17.33H7.8c-1.68 0-2.52 0-3.16-.33a3 3 0 01-1.31-1.3C3 18.71 3 17.87 3 16.2V7.8c0-1.68 0-2.52.33-3.16a3 3 0 011.3-1.31C5.29 3 6.13 3 7.8 3z"/></svg>`,
};
